import * as R from "ramda";

import { removeAccents } from "./strings";

export const getCompanyURL = companyName => {
  const normalizedCompanyName = R.pipe(
    R.toLower,
    removeAccents,
    R.replace(/ /g, "_")
  )(companyName);

  return encodeURI(
    `${process.env.REACT_APP_CANDIDATES_URL}compania/${normalizedCompanyName}`
  );
};
